var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 90,
    viewBox: "0 0 99 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0562 35.8389C51.0811 35.8389 53.0862 35.4401 54.9569 34.6652C56.8277 33.8903 58.5275 32.7545 59.9594 31.3226C61.3912 29.8908 62.527 28.191 63.3019 26.3202C64.0768 24.4494 64.4756 22.4444 64.4756 20.4194C64.4756 18.3945 64.0768 16.3895 63.3019 14.5187C62.527 12.6479 61.3912 10.9481 59.9594 9.51625C58.5275 8.08442 56.8277 6.94863 54.9569 6.17374C53.0862 5.39884 51.0811 5 49.0562 5C44.9667 5 41.0447 6.62454 38.153 9.51625C35.2613 12.408 33.6367 16.33 33.6367 20.4194C33.6367 24.5089 35.2613 28.4309 38.153 31.3226C41.0447 34.2143 44.9667 35.8389 49.0562 35.8389Z",
    fill: "#8CBB8C",
    stroke: "#024202",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.622 7.76428C20.5807 9.18343 18.9133 11.0758 17.7625 13.2796C16.6117 15.4834 16.0117 17.9331 16.0137 20.4192C16.0131 23.0797 16.7009 25.695 18.0102 28.0109C19.3195 30.3269 21.2057 32.2647 23.4855 33.6359M75.4887 7.76428C77.53 9.18343 79.1974 11.0758 80.3482 13.2796C81.499 15.4834 82.099 17.9331 82.097 20.4192C82.0994 22.9058 81.4995 25.3559 80.3487 27.5601C79.1979 29.7643 77.5303 31.657 75.4887 33.0764",
    fill: "#8CBB8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.622 7.76428C20.5807 9.18343 18.9133 11.0758 17.7625 13.2796C16.6117 15.4834 16.0117 17.9331 16.0137 20.4192C16.0131 23.0797 16.7009 25.695 18.0102 28.0109C19.3195 30.3269 21.2057 32.2647 23.4855 33.6359M75.4887 7.76428C77.53 9.18343 79.1974 11.0758 80.3482 13.2796C81.499 15.4834 82.099 17.9331 82.097 20.4192C82.0994 22.9058 81.4995 25.3559 80.3487 27.5601C79.1979 29.7643 77.5303 31.657 75.4887 33.0764",
    stroke: "#024202",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.623 79.8944V84.2999H75.4897V79.8944C75.4897 71.6846 75.4897 67.5787 74.1482 64.3384C72.3592 60.0207 68.9283 56.5906 64.6102 54.8025C61.3743 53.4611 57.2683 53.4611 49.0564 53.4611C40.8444 53.4611 36.7406 53.4611 33.5026 54.8025C31.3643 55.6882 29.4214 56.9863 27.7848 58.6228C26.1483 60.2594 24.8501 62.2023 23.9645 64.3406C22.623 67.5787 22.623 71.6846 22.623 79.8944Z",
    fill: "#8CBB8C",
    stroke: "#024202",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1111 84.3001V81.6568C93.1111 71.7884 93.1111 66.8541 91.1903 63.083C89.5008 59.7673 86.8051 57.0716 83.4894 55.3821M5 84.3001V81.6568C5 71.7884 5 66.8541 6.92082 63.083C8.6103 59.7673 11.306 57.0716 14.6217 55.3821",
    fill: "#8CBB8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1111 84.3001V81.6568C93.1111 71.7884 93.1111 66.8541 91.1903 63.083C89.5008 59.7673 86.8051 57.0716 83.4894 55.3821M5 84.3001V81.6568C5 71.7884 5 66.8541 6.92082 63.083C8.6103 59.7673 11.306 57.0716 14.6217 55.3821",
    stroke: "#024202",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.7f04e9462da029315bffadcbdf32c7f7.svg";
export { ForwardRef as ReactComponent };